import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: "https://annular-arena-331607.el.r.appspot.com",
});